import { css, Theme } from '@emotion/react'
import { Box, Typography } from '@mui/material'

import { CommentRight } from '../molecules/CommentRight'
import { CommentLeft } from '../molecules/CommentLeft'

type Props = {
  title: string
  comment: string[]
}

const Issue: React.FC<Props> = ({ title, comment }) => {
  return (
    <Box css={styles.wrapper} component='section' id='service'>
      <Box css={styles.container}>
        <Box css={styles.head}>
          <Typography variant='h1' css={styles.title} color='primary'>
            {title}
          </Typography>
          <Typography variant='h2' css={styles.question} color='primary'>
            こんな<span>お悩み</span>ありませんか？
          </Typography>
        </Box>
        <Box css={styles.comment_container}>
          <CommentRight comment={comment[0]} />
          <CommentLeft comment={comment[1]} />
          <CommentRight comment={comment[2]} />
          <CommentLeft comment={comment[3]} />
          <CommentRight comment={comment[4]} />
        </Box>
        <div css={styles.arrow}></div>
        <Typography variant='h1' css={styles.solution} color='primary'>
          その課題、
          <br />
          <span>eduad</span>が
          <br />
          解決いたします！
        </Typography>
      </Box>
    </Box>
  )
}

const styles = {
  wrapper: css`
    width: 100vw;
  `,
  container: css`
    max-width: 1180px;
    margin: 0 auto;
  `,
  head: css`
    padding: 40px 60px;
    @media (max-width: 768px) {
      padding: 40px 20px;
    }
  `,
  title: css`
    font-family: 'Noto sans JP', sans-serif;
    font-size: 3rem;
    font-weight: 700;
    margin: 4rem 2rem 6rem;
    padding-left: 40px;
    border-left: 8px solid #0d9bbe;
    @media (max-width: 960px) {
      font-size: 2.1rem;
    }
    @media (max-width: 768px) {
      padding-left: 20px;
      margin: 0rem 0rem 2rem;
      font-size: 1.6rem;
    }
  `,
  question: css`
    padding: 0 40px;
    text-align: center;
    letter-spacing: 0.3rem;
    font-family: 'Noto sans JP', sans-serif;
    font-size: 3rem;
    font-weight: 700;
    & span {
      font-size: 3.8rem;
      color: orange;
      letter-spacing: 0.1rem;
      border-bottom: 8px dotted #2d72cc;
    }
    & span:before {
      content: '\\201c';
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
    }
    & span:after {
      content: '\\201d';
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
    }
    @media (max-width: 768px) {
      padding: 20px 0;
      margin-bottom: 1rem;
      font-size: 1.4rem;
      letter-spacing: 0;
      & span {
        font-size: 2rem;
        border-bottom: 5px dotted #2d72cc;
      }
    }
  `,
  comment_container: css`
    padding-bottom: 50px;
  `,
  arrow: (theme: Theme) => css`
    position: relative;
    height: 150px;
    &:before {
      content: '';
      position: absolute;
      width: 200px;
      height: 1px;
      top: 50%;
      left: calc(50% - 200px);
      background-color: ${theme.palette.primary.main};
      transform-origin: 100% 100%;
      transform: rotate(29deg);
      @media (max-width: 768px) {
        width: 100px;
        left: calc(50% - 100px);
      }
    }
    &:after {
      content: '';
      position: absolute;
      width: 200px;
      height: 1px;
      top: 50%;
      left: 50%;
      background-color: ${theme.palette.primary.main};
      transform-origin: 0 0;
      transform: rotate(-29deg);
      @media (max-width: 768px) {
        width: 100px;
        right: calc(50% - 100px);
      }
    }
  `,
  solution: css`
    width: 100%;
    padding-bottom: 100px;
    margin: 0 auto;
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 700;
    font-size: 3rem;
    text-align: center;
    & span {
      color: #0d9bbe;
      font-size: 5rem;
    }
    @media (max-width: 768px) {
      font-size: 2rem;
      width: 70%;
      & span {
        font-size: 4rem;
      }
    }
  `,
}

export default Issue
